import React from 'react';
import Modal from 'react-responsive-modal';
import Crying_circly from '../../img/crying_circly.svg';

const UnauthorizedModal = ({ isOpen }) => {
  return (
    <Modal
      open={isOpen}
      onClose={() => (window.location.href = '/boards')}
      closeIconSize={26}
      classNames={{ modal: 'modal-bg shareDialog', closeIcon: 'close-icon' }}
      center
    >
      <div style={{ textAlign: 'center' }}>
        <h1 style={{ fontSize: '40px' }} className="m-b-3">
          404
        </h1>
        <img
          src={Crying_circly}
          alt="crying circly"
          style={{ height: '100px' }}
          className="m-b-1"
        />
        <p>
          We could not find that board. <br />
          Maybe it doesn't exist, or you don't have access to it. <br />
          You will be redirected to you own boards.
        </p>
        <button
          className="btn btn-primary m-t-2"
          onClick={() => (window.location.href = '/boards')}
        >
          OK
        </button>
      </div>
    </Modal>
  );
};

export default UnauthorizedModal;
